import { render, staticRenderFns } from "./resourceDetailItemOut.vue?vue&type=template&id=2064a57a&scoped=true"
import script from "./resourceDetailItemOut.vue?vue&type=script&lang=js"
export * from "./resourceDetailItemOut.vue?vue&type=script&lang=js"
import style0 from "./resourceDetailItemOut.vue?vue&type=style&index=0&id=2064a57a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2064a57a",
  null
  
)

export default component.exports